import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { _getRedirectResult, signInWithRedirect, _signInWithPopup, } from '../../../redux/actions';
import getBrowserVersion from '../../../scripts/getBrowserVersion';
import Button from '../../../components/Button';
import googleLogo from './google-logo.svg';
var GoogleAuthRedirect = function (props) {
    var navigate = useNavigate();
    var _a = useState(false), preferPopupAuth = _a[0], setPreferPopupAuth = _a[1];
    var _b = useState(false), displayError = _b[0], setDisplayError = _b[1];
    useEffect(function () {
        var browser = getBrowserVersion();
        if (browser.name === 'Safari' && browser.version == '16') {
            /*
            Safari 16.1 has an issue with SignInWithRedirect.
            Therefore we need to sign up with popup instead.
            Track the issue here:
            https://github.com/firebase/firebase-js-sdk/issues/6716
            */
            setPreferPopupAuth(true);
        }
        else {
            // START GOOGLE AUTH PROCESS (via redirect method)
            // 1. check if it's a second reload (after being redirected from google)
            // and in case store the result (idToken to be used to authenticate)
            _getRedirectResult()
                .then(function (user) {
                // This runs the first time the page is loaded. In this case
                // there are no redirect results, therefore Firebase starts the redirect.
                if (user === null)
                    signInWithRedirect();
                // This runs once the app receives the redirect results (second run).
                // Therefore take the result (signed up user) and proceed.
                else
                    handleSignInResult();
            })
                .catch(function (error) {
                Sentry.captureException(error);
                setDisplayError(true);
                setPreferPopupAuth(true); // prefer popup when trying again
            });
        }
    }, []);
    function handleSignInResult() {
        if (props.electronAuthCode) {
            // user is trying to authenticate on ELECTRON
            navigate('../success'); // redirect the user to a generic success page
        }
        else {
            navigate('/'); // else load dashboard
        }
    }
    return (React.createElement("div", { className: 'flex w-full max-w-xs flex-col gap-4 p-4 text-center' },
        preferPopupAuth ? (
        // Sign in with Popup
        React.createElement(Button, { icon: googleLogo, label: 'Sign in with Google', id: '', onClick: function () { return _signInWithPopup().then(handleSignInResult); } })) : (
        // Sign in with Redirect
        React.createElement("h3", null, "Signing in with Google...")),
        displayError && (React.createElement(React.Fragment, null,
            React.createElement("p", { className: 'text-sm' }, "There seems to be an issue signing in. Please try enabling Cookies on your browser or try again later."),
            React.createElement("p", { className: 'text-sm' }, "If the problem persists, contact us at support@substratum.app")))));
};
export default GoogleAuthRedirect;
